import { createSlice } from "@reduxjs/toolkit";

const timeslotSlice = createSlice({
    name:'timeslot',
    initialState:{
        timeslot:[]
    },
    reducers: {
        addTimeSlot : (state,action) => {
            console.log("test ",action)
            //state.push(action.payload)
            state.timeslot = [...state.timeslot,action.payload]
        },
        // removeOccupation(){
        //     return state.occupation.filter((item)=> item.id != action.payload);
        // }
    }
});

export const { addTimeSlot } = timeslotSlice.actions;
export default timeslotSlice.reducer;